/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { LessonStateRequestModel, Subjects } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Lessons<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Lessons
   * @name GetProgressList
   * @request GET:/Lessons/GetProgress
   * @secure
   */
  getProgressList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Lessons/GetProgress`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Lessons
   * @name GetLessonsDetail
   * @request GET:/Lessons/GetLessons/{subject}
   * @secure
   */
  getLessonsDetail = (subject: Subjects, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Lessons/GetLessons/${subject}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Lessons
   * @name LessonStateCreate
   * @request POST:/Lessons/PostLessonState
   * @secure
   */
  LessonStateCreate = (data: LessonStateRequestModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Lessons/PostLessonState`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
